export default __webpack_public_path__ + "static/media/img_01.9960d36c.jpg";